import { render, staticRenderFns } from "./DLGQRImageDownload.vue?vue&type=template&id=5d7b9a63&"
import script from "./DLGQRImageDownload.vue?vue&type=script&lang=js&"
export * from "./DLGQRImageDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7b9a63')) {
      api.createRecord('5d7b9a63', component.options)
    } else {
      api.reload('5d7b9a63', component.options)
    }
    module.hot.accept("./DLGQRImageDownload.vue?vue&type=template&id=5d7b9a63&", function () {
      api.rerender('5d7b9a63', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/components/DLGQRImageDownload.vue"
export default component.exports